import * as React from 'react';

import {TypeImplementation, Plugins} from '@packages/systems/wfdl';
import {ELiteral} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {Checkbox, View} from '@packages/systems/spring';

const createLiteralExpr = (value: boolean) =>
  ELiteral({
    name: qualify(
      Plugins.name('Animation'),
      typeName('AnimationPlayInReverse')
    ),
    value,
  });

export const playInReverse = TypeImplementation.Custom({
  render: function PlayInReverseCheckbox({dispatch, expr}) {
    const literal = ContextualExpressions.getLiteral(stripAnn(expr))?.value;
    if (literal == null) {
      return null;
    }
    // @ts-expect-error - TS2322 - Type 'string | number | boolean | Json[] | { [key: string]: Json; }' is not assignable to type 'boolean'.
    const state: boolean = literal;
    return (
      <View gridColumn="1 / -1">
        <Checkbox
          id="lottie-playinreverse-checkbox"
          label="Play in reverse"
          isChecked={state}
          onChange={() =>
            dispatch(updateExpressionAction(createLiteralExpr(!state)))
          }
        />
      </View>
    );
  },
  system: {
    labelVariant: 'hidden',
    defaultValue: false,
  },
});
